import { ICorporatePartner } from './corporate-partner.interface';

export class ConcurSpidPartner implements ICorporatePartner {
  public name = 'concur-spid';
  public displayBusinessLogo = true;
  public updateBgColor = true;
  public restrictPaxToOne = true;
  public disableMiles = true;
  public displayInlineText = 'fare';
  public showPopupForEcert = true;
  public showBusinessText = true;
  public showBusinessMilesLabel = true;
}

export class ConcurNoSpidPartner implements ICorporatePartner {
  public name = 'concur-no-spid';
  public displayBusinessLogo = true;
  public updateBgColor = true;
  public restrictPaxToOne = true;
  public disableMiles = true;
  public displayInlineText = 'noprogram';
  public showPopupForEcert = true;
  public showBusinessText = true;
  public showBusinessMilesLabel = true;
}
